import React, { useState } from "react";
import jsDig from "utils/jsDig";
import LiteMetricTable from "dashboards/lite/LiteMetricTable";
import LiteLineChart from "dashboards/lite/LiteLineChart";
import LiteRefresh from "dashboards/lite/LiteRefresh";
import YearPicker from "dashboards/lite/YearPicker";
import ObjectivePicker from "dashboards/lite/ObjectivePicker";
import DashboardOptions from "dashboards/lite/DashboardOptions";
import { capitalize } from "lodash";
import LiteExportPDF from 'utils/LiteExportPDF';

export default function SearchDashboard(props) {
  console.log(props)
  const metricTableDimensions = jsDig(["overall", "total", "total", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "total", "total", "spend"], props.table_data)) : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", "YTD", "Total"];
  const l7metricTableDimensions = jsDig(["overall", "l7_branded", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "l7_branded", "spend"], props.table_data)).filter(d => d != "total") : []
  // Convert utc date to local time in this format 12:30 PM, 12/31/2021
  const lastDataPull = new Date(jsDig(["last_data_pull"], props)).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    month: "numeric",
    day: "numeric",
    year: "numeric",
  });

  // Read the 'year' query param if it exists
  const urlParams = new URLSearchParams(window.location.search);
  const queryYear = parseInt(urlParams.get("year"), 10);

  // If queryYear is not a valid number, use the current year, else use queryYear
  const thisYear = isNaN(queryYear) ? new Date().getFullYear() : queryYear;
  const lastYear = thisYear - 1;

  let mainIcon = require("images/lite/icons/search.svg");
  mainIcon = <div className="paid-icon active dashboard-icon"><img className="dashboard-icon-2" src={`/datapulse${mainIcon}`} /></div>
  let disabledIcon = require("images/lite/icons/coming-soon.png");
  disabledIcon = <div className="coming-soon-icon"><img src={`/datapulse${disabledIcon}`} /></div>

  const [dashboardObjective, setDashboardObjective] = useState(props.client_account.dashboard_objective ? props.client_account.dashboard_objective : "sales");
  let revenueOrConversions = dashboardObjective == "sales" ? "revenue" : "conversions";
  let roasOrCpa = dashboardObjective == "sales" ? "roas" : "cpa";

  const dashboardType = "paid_search"
  const [dashboardOptions, setDashboardOptions] = useState(props.client_account.dashboard_options ? props.client_account.dashboard_options : {});
 

  return (
    <>
      <div className="lite-dashboard paid-search-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            {mainIcon}
            <h1>Paid Search Dashboard</h1>
          </div>
          <div className="dashboard-header-center">
          </div>
          <div className="dashboard-header-right flex-end">
            <div className="most-recent-refresh">
              <small id="most-recent-refresh">Last refresh: {props.last_data_pull ? lastDataPull : "Never"}</small>
            </div>
            <div className="objective-refresh-container">
              <YearPicker/>
              <ObjectivePicker setDashboardObjective={setDashboardObjective} dashboardObjective={dashboardObjective} />
              {props.user_is_employee && (
                <LiteRefresh refreshPreference={props.default_refresh_preference} currentDashboard={"search"} accountId={props.client_account.id} alreadyPulling={props.current_data_pulls} />
              )}
              <DashboardOptions dashboardOptions={dashboardOptions} setDashboardOptions={setDashboardOptions} dashboardType={dashboardType} accountId={props.client_account.id} />
              <LiteExportPDF companyName={props.company_name} dashName="Paid-Search" />
            </div>
          </div>
        </div>

        <div className="dashboard-body">
          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "spend", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "spend", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "spend", "data"], props.chart_data)}
                chartName="Search Spend L60D (infl.)"
                metric="spend"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", revenueOrConversions, "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", revenueOrConversions, "labels"], props.chart_data)}
                data={jsDig(["overall", "total", revenueOrConversions, "data"], props.chart_data)}
                chartName={`Search ${capitalize(revenueOrConversions)} L60D (infl.)`}
                metric={revenueOrConversions}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", roasOrCpa, "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", roasOrCpa, "labels"], props.chart_data)}
                data={jsDig(["overall", "total", roasOrCpa, "data"], props.chart_data)}
                chartName={`Search ${roasOrCpa.toUpperCase()} L60D (infl.)`}
                metric={roasOrCpa}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={
                  {
                    "overall": jsDig(["overall", "total", "total"], props.table_data),
                    "google ads": jsDig(["google_ads", "total", "total"], props.table_data),
                    "microsoft ads": jsDig(["microsoft_ads", "total", "total"], props.table_data)
                  }
                }
                tableName="Search"
                dimensions={metricTableDimensions}
                groups={["Overall", "Google Ads", "Microsoft Ads"]}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "branded_vs_nonbranded", "spend", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "branded_vs_nonbranded", "spend", "labels"], props.chart_data)}
                data={jsDig(["overall", "branded_vs_nonbranded", "spend", "data"], props.chart_data)}
                chartName="Branded vs. Non-Branded L60D"
                metric="stacked"
                tooltipData={jsDig(["overall", "branded_vs_nonbranded", "spend", "tooltip_data"], props.chart_data)}
                tooltipMetric="spend"
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", "clicks", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["overall", "nonbranded"], props.table_data)}
                tableName="Non-Branded"
                skipPrev={true}
                dimensions={metricTableDimensions}
                groups={["Total", "Shopping", "Text", "Uncategorized"]}
              />
            </div>
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", "clicks", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["overall", "branded"], props.table_data)}
                tableName="Branded"
                skipPrev={true}
                dimensions={metricTableDimensions}
                groups={["Total", "Shopping", "Text", "Uncategorized"]}
              />
            </div>
          </div>
          <div className="lite-dashboard-section triple-chart-row">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", "clicks", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["overall", "display"], props.table_data)}
                tableName="Display"
                skipPrev={true}
                dimensions={metricTableDimensions}
                groups={["Total", "Prospecting", "Remarketing", "Uncategorized"]}
              />
            </div>
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", "clicks", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["overall", "demand_gen"], props.table_data)}
                tableName="Demand Gen"
                skipPrev={true}
                dimensions={metricTableDimensions}
                groups={["Total", "Prospecting", "Remarketing", "Uncategorized"]}
              />
            </div>
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", "clicks", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["overall", "youtube"], props.table_data)}
                tableName="Youtube"
                skipPrev={true}
                dimensions={metricTableDimensions}
                groups={["Total", "Prospecting", "Remarketing", "Uncategorized"]}
              />
            </div>
          </div>
          {jsDig([dashboardType, "show_branded_and_non_branded_l7d_tables", "enabled"], dashboardOptions) && (
            <div className="lite-dashboard-section">
              <div className="lite-metric-table">
                <LiteMetricTable
                  headerOrder={["spend", "clicks", revenueOrConversions, roasOrCpa]}
                  subHeaderOrder={[thisYear, "Y/Y"]}
                  data={jsDig(["overall", "l7_branded"], props.table_data)}
                  tableName="Branded - Daily L7D (infl.)"
                  skipPrev={true}
                  dimensions={l7metricTableDimensions}
                  topSummaryRow={{dimension: "L7D >", data: jsDig(["overall", "l7_branded"], props.table_data)}}
                />
              </div>
              <div className="lite-metric-table">
                <LiteMetricTable
                  headerOrder={["spend", "clicks", revenueOrConversions, roasOrCpa]}
                  subHeaderOrder={[thisYear, "Y/Y"]}
                  data={jsDig(["overall", "l7_nonbranded"], props.table_data)}
                  tableName="Non-Branded - Daily L7D (infl.)"
                  skipPrev={true}
                  dimensions={l7metricTableDimensions}
                  topSummaryRow={{dimension: "L7D >", data: jsDig(["overall", "l7_nonbranded"], props.table_data)}}
                />
              </div>
            </div>
          )}
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["overall", "l60"], props.table_data)}
                tableName="Total Search - Daily L60D (infl.)"
                dimensions={jsDig(["overall", "l60", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "l60", "spend"], props.table_data)) : []}
                topSummaryRow={{dimension: "L7D >", data: jsDig(["overall", "l7"], props.table_data)}}
                collapsed={true}
              />
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
